import { edmCampaign } from '@bingads-webui/edm-campaign';

export const readAudienceDataFactory = ({ model, filterOnServer }) => (
  (cid, aid, search) =>
    edmCampaign
      .Customers.$withKey(cid)
      .Accounts.$withKey(aid)
      .Demographics.$cast(model)
      .get({
        // Currently, there's an issue in MT side with JobFunction because it reuses the existing api.
        // It'll error if servingChannel is passed, so we need to remove it for this case.
        ...(model !== 'Model.JobFunction' ? { servingChannel: 'LinkedIn' } : {}),
        ...(filterOnServer ? { search, top: 10 } : {}),
      })
      .toPromise()
);

export const readCompanyNames = readAudienceDataFactory({ model: 'Model.Company', filterOnServer: true });
export const readCompanyIndustries = readAudienceDataFactory({ model: 'Model.Industry', filterOnServer: false });
export const readJobSeniorities = readAudienceDataFactory({ model: 'Model.JobSeniority', filterOnServer: false });
export const readJobFunctions = readAudienceDataFactory({ model: 'Model.JobFunction', filterOnServer: false });
export const readJobTitles = readAudienceDataFactory({ model: 'Model.JobTitle', filterOnServer: true });

